import { useInfiniteQuery } from 'react-query'
import { Response } from 'request-dot-js/index'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { reportError } from 'utils/error'
import { getNextPageParam } from 'utils/getNextPageParam'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Notification } from '../NotificationItem/types'
import qs from 'qs'
import { isAlmanacCoreWorkspace } from 'utils/workspaceUtils'

interface Props {
  read?: boolean
  seen?: boolean
  items?: number
  enabled?: boolean
}

export const useNotificationsQuery = ({ read, seen = undefined, items = 20, enabled = true }: Props) => {
  const currentWorkspace = useCurrentWorkspace()
  const currentWorkspaceId = currentWorkspace?.id
  const currentWorkspaceKey = currentWorkspace?.key
  const queryKey = ['useNotifications', read, seen, currentWorkspaceKey]
  const { notifications } = useRootStore()

  const fetchNotifications = async (currentWorkspaceKey: string, params: string) => {
    return sendToApi<{ notifications: Notification[] }>(`/w/${currentWorkspaceKey}/notifications?${params}`).then(
      (response) => {
        if (response.type === SUCCESS_RESPONSE_TYPE) {
          notifications.bulkAdd(response.data.notifications)

          return Promise.resolve(response)
        } else {
          return Promise.reject(response)
        }
      },
    )
  }

  return useInfiniteQuery<Response<{ notifications: Notification[] }>>(
    queryKey,
    ({ pageParam = 1, queryKey: [_, read, seen, __] }) => {
      const params = qs.stringify({ read, seen, items, page: pageParam })
      return fetchNotifications(currentWorkspaceKey || '', params)
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      getNextPageParam,
      enabled:
        enabled && !!currentWorkspaceId && !currentWorkspace?.guest && !isAlmanacCoreWorkspace(currentWorkspaceId),
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
    },
  )
}
